import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Sentís que improvisás los entrenamientos a último momento.', 'Tenés grupos infantiles desordenados y cuesta mantener su atención.', 'Llega gente nueva de diferentes niveles y no sabés cómo integrarlos.', 'Te faltan materiales o espacio y la clase pierde intensidad.', 'Terminás frustrado porque los jugadores no aplican lo practicado en los partidos.'];
  return <section className="py-12 px-4 bg-blue-50" data-id="element-121">
      <div className="max-w-3xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center text-slate-900 mb-8 uppercase" data-id="element-123">
          ¿Te pasa que llegás a tus clases y...
        </h2>

        <div className="space-y-4" data-id="element-124">
          {points.map((point, index) => <div key={index} className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm border border-blue-100" data-id="element-125">
              <XCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-126" />
              <p className="text-slate-800 font-medium text-lg" data-id="element-127">{point}</p>
            </div>)}
        </div>
      </div>
    </section>;
}